import BaseModel from './base-model.js'

class Settings extends BaseModel {
    /**
     * Set the title of the model
     */
    title = 'Settings'
    /**
     * Set the id of the model
     */
    route = 'settings'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = ''

    get = async (section = null, key = null) => {
        let response = await this.instance().get(`/${this.route}`, { params: { section, key } })

        return response.data
    }

    update = async (data) => {
        let response = await this.instance().post(`/${this.route}`, data)

        return response.data
    }

    saveSetupStep = async (data) => {
        let response = await this.instance().post(`/${this.route}/save_setup_step`, data)
      
        return response.data
    }
}

export default Settings
